/**
 * The sound settings the shell reads on every page, apart from the sounds
 * themselves (learnconcept, 9 Oct 2026). The first load sits at its 350 KB
 * ceiling (FAST_PHONE_SPEC); `notificationSound.ts` is 6 KB of synthesis that
 * only a sound needs, so the shell reads these and imports the rest when a
 * sound plays. `notificationSound.ts` re-exports them, so nothing else moves.
 */

/** Whether alert pop-ups are currently turned off. */
export function isAlertPopupsMuted(): boolean {
    try { return localStorage.getItem('karr_alert_popups') === 'off'; } catch { return false; }
}

/** Whether UI ticks are on (default on). */
export function isUiSoundOn(): boolean {
    try { return localStorage.getItem('karr_ui_sound') !== 'off'; } catch { return true; }
}

/** Volume 0..1 ('karr_ui_sound_vol', default 0.6). */
export function getUiVolume(): number {
    try {
        const v = parseFloat(localStorage.getItem('karr_ui_sound_vol') ?? '');
        return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0.6;
    } catch { return 0.6; }
}
